/**
 * use-scroll-memory.ts — Nhớ + khôi phục vị trí cuộn của danh sách hội thoại qua lại giữa màn danh sách và
 * màn chi tiết trên điện thoại. `ConversationList` bị UNMOUNT hoàn toàn mỗi khi mở 1 hội thoại (và mount lại
 * từ đầu khi quay về — xem nhánh `activeId` trong conversations-page.tsx), nên tự nó không giữ được vị trí
 * cuộn qua lần unmount/mount đó.
 *
 * `memory` là một ref sống Ở COMPONENT CHA (ConversationsPage — không unmount khi đổi route `/conversations`
 * ⇄ `/conversations/:id`), truyền xuống đây để giá trị còn nguyên qua lần unmount/mount của chính danh sách.
 * Cùng cách đọc viewport cuộn thật qua `[data-radix-scroll-area-viewport]` như use-scroll-collapse.ts.
 *
 * Giả định: `ConversationsPage` không unmount nên dữ liệu danh sách (react-query) vẫn còn trong bộ nhớ đệm lúc
 * mount lại — danh sách có ngay, không phải đợi tải lại rồi mới đủ cao để cuộn đúng vị trí cũ.
 */
import { useEffect, type MutableRefObject, type RefObject } from 'react'

export function useScrollMemory(ref: RefObject<HTMLElement | null>, memory: MutableRefObject<number>, enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return
    const el = ref.current
    if (!el) return
    const viewport = el.querySelector<HTMLElement>('[data-radix-scroll-area-viewport]')
    if (!viewport) return

    viewport.scrollTop = memory.current
    const onScroll = () => { memory.current = viewport.scrollTop }
    viewport.addEventListener('scroll', onScroll, { passive: true })
    return () => viewport.removeEventListener('scroll', onScroll)
  }, [ref, memory, enabled])
}
